var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w1200 newsBox"},[_c('div',{staticClass:"bannerbox",style:('background-image:url('+_vm.banner_big+')')}),_c('div',{staticClass:"content w1200"},[_c('pushu'),_c('puxi'),_c('puwen'),_c('purenwu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }